// Nexi logo
import xpayLogo from 'Assets/svg/xpay_logo.svg'
// import nexiLogoLight from 'Assets/svg/nexi_logo_light.svg'
import nexiLogoDark from 'Assets/svg/nexi_logo_dark.svg'

// UCI logo
import uciLogo from 'Assets/svg/uci_logo.svg'
// import uciLogoWhite from 'Assets/svg/uci_logo_white.svg'

// ISP
import ispLogo from 'Assets/svg/isp-nexi_logo.svg'
// import ispLogoWhite from 'Assets/svg/isp-nexi_logo_white.svg'

export const bankServiceMapping = {
  nexi: {
    title: 'Nexi',
    logo: {
      default: nexiLogoDark,
      footerLogo: xpayLogo
      // light: nexiLogoLight,
      // dark: nexiLogoDark
    },
    footer: {
      linkPrivacy: 'https://www.nexigroup.com/en/privacy-policy/',
      linkCookies: 'https://www.nexigroup.com/en/cookie-policy/'
    }
  },
  'unicredit-e-platform': {
    title: 'UCI',
    logo: {
      default: uciLogo,
      footerLogo: xpayLogo
      // white: uciLogoWhite,
    },
    footer: {
      linkPrivacy: 'https://www.unicredit.it/it/info/privacy.html',
      linkCookies: 'https://www.unicredit.it/it/info/cookie-policy.html'
    }
  },
  isp: {
    title: 'ISP',
    logo: {
      default: ispLogo,
      footerLogo: xpayLogo
      // white: uciLogoWhite,
    },
    footer: {
      linkPrivacy: 'https://www.nexigroup.com/en/privacy-policy/',
      linkCookies: 'https://www.nexigroup.com/en/cookie-policy/'
    }
  }
}